import ImageAiNew from "../ImageAiNew/ImageAiNew";
const GenerateImage = () => {
  return (
    <ImageAiNew />
  );
};

export default GenerateImage;
